import {
	Stack,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from '@mui/material';
import React from 'react';
import { IAuditEvent } from 'types/api';
import { getAuditEventLabel, getAuditEventUser } from 'utils/auditUtils';
import { AuditStatusChip, AuditTestChip } from './AuditEventChips';

interface IAuditEventsTableProps {
	events: IAuditEvent[];
	onEventClick: (event: IAuditEvent) => void;
}

const AuditEventsTable: React.FC<IAuditEventsTableProps> = ({
	events,
	onEventClick
}) => (
	<TableContainer>
		<Table>
			<TableHead>
				<TableRow>
					<TableCell>{intl.tr('audit.table.time')}</TableCell>
					<TableCell>{intl.tr('audit.table.event')}</TableCell>
					<TableCell>{intl.tr('audit.table.user')}</TableCell>
					<TableCell>{intl.tr('audit.table.status')}</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{events.map((event) => (
					<TableRow
						key={event.id}
						hover
						tabIndex={0}
						data-testid="audit-event-row"
						sx={{ cursor: 'pointer' }}
						onClick={() => onEventClick(event)}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								onEventClick(event);
							}
						}}
					>
						<TableCell sx={{ whiteSpace: 'nowrap' }}>
							{intl.tr('audit.event.time', { time: event.occurred })}
						</TableCell>
						<TableCell>
							{/* Wraps the test chip under the label when the sidebar narrows the table. */}
							<Stack
								direction="row"
								gap={1}
								alignItems="center"
								flexWrap="wrap"
							>
								{getAuditEventLabel(event)}
								<AuditTestChip event={event} />
							</Stack>
						</TableCell>
						<TableCell sx={{ wordBreak: 'break-all' }}>
							{getAuditEventUser(event) || '-'}
						</TableCell>
						<TableCell>
							<AuditStatusChip event={event} />
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	</TableContainer>
);

export default AuditEventsTable;
